export default {"src":"/_next/static/image/public/images/UsersThree.d0527a8c925dd762fc72d2b0cf7ce747.svg","height":18,"width":18};